var _metadata;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "6.82666in",
    height: "6.82666in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 6.82666 6.82666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_555623432"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_555623168",
    style: {
      fill: "#212121",
      fillRule: "nonzero"
    },
    points: "4.44384,4.88825 4.86924,5.14459 4.75924,5.32709 4.33384,5.07075 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_555623192",
    style: {
      fill: "#212121",
      fillRule: "nonzero"
    },
    points: "5.30902,3.45252 5.73442,3.70886 5.62442,3.89137 5.19902,3.63502 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "_555623336",
    style: {
      fill: "#212121",
      fillRule: "nonzero"
    },
    d: "M4.88091 5.31876l-0.557976 0.450079 -0.171248 -0.1025 0.132575 -0.706421 0.0133307 -0.0354173 1.02939 -1.70825c0.0275394,-0.0457087 0.0667795,-0.0805709 0.107791,-0.0999016 0.0548307,-0.0258425 0.114252,-0.0265906 0.165012,0.004l0.292465 0.176244c0.0506929,0.0305472 0.0777756,0.0835157 0.0805472,0.144244 0.00206299,0.0452244 -0.0104055,0.0961181 -0.0379055,0.14176l-1.0294 1.70825 -0.0245866 0.0279173zm-0.466843 0.103185l0.318406 -0.256835 1.01992 -1.69252c0.00184646,-0.00306693 0.00337008,-0.00599606 0.00456693,-0.00874409l-0.241854 -0.145744c-0.00187402,0.00234252 -0.00375984,0.00506299 -0.00561417,0.00814173l-1.01969 1.69214 -0.0757362 0.403555z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_555622880",
    style: {
      fill: "#212121",
      fillRule: "nonzero"
    },
    d: "M4.19094 4.27307c-0.0448701,-0.115768 -0.15628,-0.231209 -0.293047,-0.335563 -0.300122,-0.229 -0.707705,-0.393055 -0.859606,-0.417217 -0.172291,-0.0273976 -0.174374,-0.343953 -0.174382,-0.344858l-0.000543307 -0.0452874 0.031378 -0.0313819c0.000629921,-0.000629921 0.219669,-0.217476 0.267071,-0.506992l0.0146693 -0.0895866 0.0903307 0c0.00133071,0 0.00109055,-0.00355512 0.00598819,-0.00932283 0.0134803,-0.015874 0.0250394,-0.0388543 0.033622,-0.0655591 0.00931102,-0.0289685 0.0145354,-0.061622 0.0145354,-0.0942835 0,-0.046126 -0.0102953,-0.0881181 -0.0347402,-0.108878l-0.0399291 -0.0339094 0.00242913 -0.0519252c0.00073622,-0.0157953 0.00257087,-0.032811 0.0048937,-0.0544291 0.00505512,-0.0470433 0.0127362,-0.118433 0.0127362,-0.202689 0,-0.257917 -0.082437,-0.63378 -0.626886,-0.63378 -0.544449,0 -0.626878,0.37587 -0.626878,0.633787 0,0.0842362 0.00767717,0.15561 0.0127323,0.202654 0.00232283,0.0216378 0.00415748,0.0386575 0.0048937,0.0544567l0.00242913 0.0519291 -0.0399291 0.0339055c-0.0244449,0.0207598 -0.0347362,0.062752 -0.0347362,0.108874 0,0.0326614 0.00522441,0.065315 0.0145354,0.0942835 0.00858268,0.0267047 0.0201496,0.0496929 0.033626,0.065563 0.00489764,0.00576772 0.00466142,0.00932283 0.00599213,0.00932283l0.0903346 0 0.0146654 0.0895866c0.0474016,0.289512 0.266433,0.506362 0.267063,0.506992l0.0313819 0.0313819 -0.000547244 0.0452874c-7.87402e-006,0.000905512 -0.00208268,0.317461 -0.174378,0.344858 -0.151898,0.0241614 -0.559488,0.188217 -0.85961,0.41722 -0.136768,0.104354 -0.248177,0.219795 -0.293047,0.335559l3.10295 0z"
  }))), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 6.82666,
    height: 6.82666
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProfile);
export default __webpack_public_path__ + "static/media/update_profile.afc43902e78467f071301fd461934589.svg";
export { ForwardRef as ReactComponent };